import { HttpClient, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { environment } from "../../environments/environment";

@Injectable({
    providedIn: 'root'
})
export class UrlImportacaoService {

    constructor() {}

    limparParametroImportDaUrl() {
        try {
            const url = new URL(window.location.href);
            if (url.searchParams.has('import')) {
                url.searchParams.delete('import');
                window.history.replaceState({}, document.title, url.toString());
            }
        } catch (error) {
            console.error('❌ Erro ao limpar parâmetro import da URL:', error);
        }
    }    

}
